import { type Color } from '@mui/material'

export const postYellow = {
  100: '#AF7D36',
  200: '#C58E42',
  300: '#CC9D5B',
  400: '#D4AC74',
  500: '#E1C59E',
  600: '#EAD6BA',
  700: '#F2E6D5',
  800: '#F6EEE3',
  900: '#FBF7F1',
} satisfies Partial<Color>
